import type { TOC } from '@ember/component/template-only'
import type { ThemeKeys } from 'teacher-ui-client/utils/themes'
import { eq } from 'ember-truth-helpers'
import t from 'ember-intl/helpers/t'
import type { TeacherWithCsvMeta } from 'teacher-ui-client/services/teacher'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'

interface Signature {
  Element: HTMLTableElement
  Args: {
    themeKey?: ThemeKeys
    rows: TeacherWithCsvMeta[]
  }
}

export const SuccessTable: TOC<Signature> = <template>
  <table ...attributes>
    <thead>
      <tr
        class="{{if (eq @themeKey 'blue') 'bg-oceany-blue-100'}}
          {{if (eq @themeKey 'green') 'bg-ms-green-100'}}
          {{if (eq @themeKey 'dark-blue') 'bg-wl-blue-100'}}"
      >
        <th />
        <th class="px-4 py-2">{{t "manage.bulkActions.csv.lineNo"}}</th>
        <th class="px-4 py-2">{{t "manage.persons.edit.firstName"}}</th>
        <th class="px-4 py-2">{{t "manage.persons.edit.lastName"}}</th>
        <th class="px-4 py-2">{{t "manage.persons.edit.email"}}</th>
        <th class="px-4 py-2">{{t "manage.teachers.trialIndicator"}}</th>
      </tr>
    </thead>
    <tbody>
      {{#each @rows as |row index|}}
        <tr
          data-test-row={{index}}
          class="{{if (eq @themeKey 'blue') 'even:bg-oceany-blue-50 hover:bg-oceany-blue-100'}}
            {{if (eq @themeKey 'green') 'even:bg-ms-green-50 hover:bg-ms-green-100'}}
            {{if (eq @themeKey 'dark-blue') 'even:bg-wl-blue-50 hover:bg-wl-blue-100'}}"
        >
          <td class="px-4 py-2 text-center">
            <PhosphorIcon @icon="phosphor-check-circle-fill" />
          </td>
          <td class="px-4 py-2">
            {{row.rowIndex}}
          </td>
          <td class="px-4 py-2">
            {{row.firstName}}
          </td>
          <td class="px-4 py-2">
            {{row.lastName}}
          </td>
          <td class="px-4 py-2">
            {{row.email}}
          </td>
          <td class="px-4 py-2">
            {{row.trialIndicator}}
          </td>
        </tr>
      {{/each}}
    </tbody>
  </table>
</template>
